import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 512 512"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M0 168V24C0 10.7 10.7 0 24 0h144c9.7 0 18.5 5.8 22.2 14.8s1.7 19.3-5.2 26.2l-39 39 87 87c9.4 9.4 9.4 24.6 0 33.9l-32 32c-9.4 9.4-24.6 9.4-33.9 0l-87-87L41 185c-6.9 6.9-17.2 8.9-26.2 5.2S0 177.7 0 168m512 176v144c0 13.3-10.7 24-24 24H344c-9.7 0-18.5-5.8-22.2-14.8s-1.7-19.3 5.2-26.2l39-39-87-87c-9.4-9.4-9.4-24.6 0-33.9l32-32c9.4-9.4 24.6-9.4 33.9 0l87 87 39-39c6.9-6.9 17.2-8.9 26.2-5.2s14.8 12.5 14.8 22.2h.1Z"
    }, null, -1)
  ]))]))
}
export default { render: render }